 /* eslint-disable no-multi-spaces */
import Vue from 'vue'
 /* eslint-disable no-unused-vars */
import Resource from 'vue-resource'
import _ from 'lodash'

// mixins
/* eslint-disable no-multi-spaces */
import lang        from './mixins/lang'
import uid         from './mixins/uid'
import validator   from './mixins/validate'

// root components ~ loaded directly from HTML
/* eslint-disable no-multi-spaces */
import set       from './components/workflows/set'
import dynamic   from './components/workflows/dynamic.vue'
import login     from './components/Login'
import logout    from './components/Logout'

// config
import config from './config/init'

// dynamic template loader ~ import any additional load styles here
/* eslint-disable no-multi-spaces */
import { dynamicWorkflowHook } from './helpers'
// import popup             from './fragment_templates/popup'
// import tabber            from './fragment_templates/membertab'
// import memberProfile    from './components/nav/member-profile.vue'
import dataGrid from './components/tables/datagrid'
import stepper from './components/progress/steppers/stepper'

// vuex
/* eslint-disable no-multi-spaces */
import store from './vuex/Store'
import { dynamicWorkflows } from './vuex/getters'
// import * as actions from './vuex/actions'

// Register vue dependencies and mixins
Vue.use(Resource)
Vue.mixin(lang)
Vue.mixin(validator)
Vue.mixin(uid)

// Debugging options
if (config.debug === true) {
  Vue.config.debug = true
  Vue.config.silent = false
  Vue.config.devtools = true
}

// Create a new workflow.
dynamicWorkflowHook()

// Global components
import { inputs } from './components/inputs/index'

_.forOwn(inputs, (component, name) => {
  Vue.component(name, component)
})

// Global transitions
import Transitions from './transitions'

_.forOwn(Transitions, (transition, name) => {
  Vue.transition(name, transition)
})

window.form = {}

/* eslint-disable no-new */
new Vue({
  el: config.vmTarget,
  store,
  data: {
    container: config.container,
    modal: false,
    fullscreen: false,
    inline: false
  },
  computed: {
    dynamicWQ () {
      return this.dynamicWorkflows
    },
    workflow () {
      /* eslint-disable no-undef */
      if (localStorage['tab::workflow'] !== undefined) {
        let wf = JSON.parse(localStorage['tab::workflow'])
        localStorage.removeItem('tab::workflow')
        return wf
      }
      return {
        id: 'MEMBER.SELF.AMEND',
        // params: { workflowParameters: {
        //   level: '04'
        // }},
        params: {
          // workflowParameters: { 'scheme': '1302' }
        },
        opts: {
          inlineErrors: false,
          notices: false
        },
        sID: 'MEMBER'
      }
    }
  },
  vuex: {
    getters: {
      dynamicWorkflows
    }
  },
  components: {
    workflow: set,
    'dynamic-workflow': dynamic,
    login,
    logout,
    stepper,
    // popup,
    dataGrid
    // tabber,
    // 'member-profile': memberProfile
  },
  methods: {
    load (fragment) {
      this.$set(fragment, true)
    },
    queryParams (url) {
      return _.split(_.last(_.split(url, '?')), '&')
        .reduce((res, xs) => {
          let [k, v] = xs.split('=')
          return _.set(res, k, v)
        }, {})
    }
  },
  ready () {}
  // created () {
  //   let url = window.location.href
  //   if (url.indexOf('?') > -1) {
  //     let params = this.getParams(url)
  //     if (_.has(params, 'wID')) {
  //       this.$set('wID', params.wID)
  //       this.$set('sID', params.sID)
  //     }
  //   }
  // }
})



// WEBPACK FOOTER //
// ./src/main.js